const state = {
  online: false
}

const mutations = {
  setOnline (state) {
    state.online = navigator.onLine
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
